import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProductForm from "../components/ProductForm";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";

// Use environment variable for backend URL, default to localhost for local development
// const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

const getAuthHeaders = () => {
  const token = localStorage.getItem("admin-token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default function EditProductsPage() {
  const { id } = useParams(); // Get the ID from the URL
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch the specific product data from the backend
    const fetchProduct = async () => {
      try {
        const BACKEND_URL =
          process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
        const response = await axios.get(
          `${BACKEND_URL}/dashboard-admin/products/${id}`,
          {
            headers: getAuthHeaders(),
          },
        );
        setProduct(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch product for editing:", err);
        setError("Product not found or failed to load.");
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]); // Re-run effect if ID changes

  const handleSuccess = () => {
    navigate("/dashboard-admin/products");
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-md rounded">
      <button
        onClick={() => navigate("/dashboard-admin/products")}
        className="text-gray-600 hover:text-gray-900 transition-colors"
        title="Back to Products"
      >
        <FaArrowLeft className="w-5 h-5" />
      </button>
      <h2 className="text-xl font-bold mb-4">Edit Product</h2>
      {/* Pass the fetched product and the update onSuccess handler to the form */}
      <ProductForm product={product} onSuccess={handleSuccess} />
    </div>
  );
}
